import axios from 'axios';

// A mock function to mimic making an async request for data
export async function fetchLinksAPI(payload) {
    const res = await axios.get(process.env.REACT_APP_URL2 + '/api/window-sticker-page-links?dealership=' + payload.dealership + '&vin=' + payload.vin);
    return res.data;
}
